<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h15">ROPED PLAYLIST</h1>
<p class="p12"> </p>
<p class="p12">Ludacris—Growing Pains</p>
<p class="p12">Judas Priest—Turbo Lover</p>
<p class="p12">Three Days Grace—Pain</p>
<p class="p12">Greg Holden—The Lost Boy</p>
<p class="p12">Joshua James—Coal War</p>
<p class="p12">Secondhand Serenade—A Twist In My Story</p>
<p class="p12">Anthrax—Madhouse</p>
<p class="p12">Incubus—Drive</p>
<p class="p12">Molly Hatchet—Flirtin’ With Disaster</p>
<p class="p12">Alice Cooper—I’m Eighteen</p>
<p class="p12">Rock Riot—Carry On Wayward Son</p>
<p class="p12">Johnny Cash—Hurt</p>
<p class="p12">Oasis—Wonderwall</p>
<p class="p12">Scorpions—Rock You Like A Hurricane</p>
<p class="p12">Alice Cooper—Poison</p>
<p class="p12">The Goo Goo Dolls—Iris</p>
<p class="p12">AC/DC—Highway To Hell</p>
<p class="p12">Mötley Crüe—Shout At The Devil</p>
<p class="p12">Five Finger Death Punch—Bad Company</p>
<p class="p14"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?568dbdca